export default "__VITE_ASSET__CK6vksEi__"